import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as l } from "../SvgIcon.js";
const i = (e) => /* @__PURE__ */ o(l, { ...e, children: /* @__PURE__ */ o(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM7.19849 5.80099L14.4815 10.0071L7.19849 14.2131L7.19849 5.80099Z"
  }
) });
export {
  i as Play
};
//# sourceMappingURL=Play.js.map
